import React, { useEffect, useState } from 'react';
import { Box, List, ListItem, ListItemIcon, ListItemText, Collapse, useMediaQuery, useTheme, SwipeableDrawer } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { getCategories, getsubCategories, getBrands, getSwipped } from '../Redux/Categories/action';
import { storage } from '../Config/Storage';
import Styles from '../Config/Styles';
import { getProducts } from '../Redux/Products/action';
import { useSwipeable } from "react-swipeable";
import Cashback from './Cashback';
import Loader from './Loader';

const Sidebar = () => {
  const { list, sublist, swipped } = useSelector((state) => state?.CategoriesData) || [];
  const dispatch = useDispatch();
  const theme = useTheme();
  const [categories, setCategories] = useState([]);
  const [openCategory, setOpenCategory] = useState('All Products'); // Track which category is expanded
  const [opensubCategory, setOpensubCategory] = useState(''); // Track which category is expanded
  const isMobile = useMediaQuery(theme.breakpoints?.down("lg"));
  const [drawerOpen, setDrawerOpen] = useState(isMobile ? swipped : true);
  const [loading, setLoading] = useState(true);
  let data = {
    page: 1,
    search: ""
  }
  useEffect(() => {
    if (categories?.length === 0) {
      dispatch(getCategories());
      dispatch(getBrands())
      dispatch(getProducts(data, setLoading))
      storage.set.category_name("All Products")
      setOpenCategory("All Products")
    }
    setCategories(list?.data);

  }, [list, sublist, swipped]);

  const handleToggle = (index, id, name) => {
    // Toggle the clicked category
    setLoading(true)
    dispatch(getBrands({ id }))
    dispatch(getsubCategories({ id }, setLoading));
    storage.set.category_name(name)
    setOpenCategory(index);
    setOpensubCategory('');
  };

  const handleAll = () => {
    if (isMobile)
      dispatch(getSwipped(false))

    setLoading(true)
    setOpenCategory("All Products")
    storage.set.category_name("All Products")
    dispatch(getBrands())
    dispatch(getProducts(data, setLoading))
  }
  const handleClick = (index, id, name) => {
    if (isMobile)
      dispatch(getSwipped(false))
    setLoading(true)
    setOpensubCategory(opensubCategory === index ? null : index);
    dispatch(getBrands({ id }))
    storage.set.category_name(name)
    Object.assign(data, { id })
    dispatch(getProducts(data, setLoading));
  }


  return (
    <>
      <Loader open={loading} />
      {!isMobile ? <Box className="box" sx={Styles.sidebar().box}>
        <List>
          {/* All Products */}
          <ListItem button sx={Styles.sidebar(openCategory).listitem} onClick={handleAll}>
            <ListItemIcon sx={Styles.sidebar().listicon}>
              <img src={require('../assets/all.png')} style={Styles.sidebar().listimg} alt="All Products" />
            </ListItemIcon>
            <ListItemText
              primary="All Products"
              primaryTypographyProps={{
                sx: { fontWeight: 'bold', fontSize: "17px" }
              }}
            />
          </ListItem>

          {/* Categories */}
          {categories?.map((category, index) => (
            <React.Fragment key={index}>
              <ListItem
                button
                sx={Styles.sidebar(opensubCategory === '' ? openCategory : "", "", index, "").listitem1}
                onClick={() => handleToggle(index, category?.id, category?.name)}
              >
                <ListItemIcon sx={Styles.sidebar().listicon}>
                  {category?.icons && (
                    <img
                      src={`https://api-dev.tabta.net/assets/${category?.icons}/?cache-buster=2024-12-30T08:26:27.522Z&key=system-large-contain`}
                      style={Styles.sidebar().listimg}
                      alt={category?.name}
                    />
                  )}
                </ListItemIcon>
                <ListItemText
                  primary={category?.name}
                  primaryTypographyProps={{
                    sx: { fontWeight: 'bold', fontSize: "17px" }, // Set font weight directly
                  }}
                />
                {category.hasPromo && <Cashback />}
              </ListItem>

              {/* Subcategories */}
              <Collapse in={openCategory === index} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {sublist?.data?.map((sub, subIndex) => (
                    <ListItem
                      key={subIndex}
                      button
                      sx={Styles.sidebar(openCategory, opensubCategory, index, subIndex).sublist}
                      onClick={() => handleClick(subIndex, sub?.id, sub?.name)}
                    >
                      <ListItemIcon sx={Styles.sidebar().listicon} />
                      <ListItemText
                        primary={sub?.name}
                        primaryTypographyProps={{
                          sx: { fontWeight: 'normal', fontSize: "17px" },
                        }}
                      />
                    </ListItem>
                  ))}
                </List>
              </Collapse>
            </React.Fragment>
          ))}
        </List>
      </Box >
        : <>
          <SwipeableDrawer
            onClose={() => { dispatch(getSwipped(false)) }}
            open={swipped}
          >
            <Box className="box" sx={Styles.sidebar().box}>
              <List>
                {/* All Products */}
                <ListItem button sx={Styles.sidebar(openCategory).listitem} onClick={handleAll}>
                  <ListItemIcon sx={Styles.sidebar().listicon}>
                    <img src={require('../assets/all.png')} style={Styles.sidebar().listimg} alt="All Products" />
                  </ListItemIcon>
                  <ListItemText
                    primary="All Products"
                    primaryTypographyProps={{
                      sx: { fontWeight: 'bold', fontSize: "17px" }
                    }}
                  />
                </ListItem>

                {/* Categories */}
                {categories?.map((category, index) => (
                  <React.Fragment key={index}>
                    <ListItem
                      button
                      sx={Styles.sidebar(opensubCategory === '' ? openCategory : "", "", index, "").listitem1}
                      onClick={() => handleToggle(index, category?.id, category?.name)}
                    >
                      <ListItemIcon sx={Styles.sidebar().listicon}>
                        {category?.icons && (
                          <img
                            src={`https://api-dev.tabta.net/assets/${category?.icons}/?cache-buster=2024-12-30T08:26:27.522Z&key=system-large-contain`}
                            style={Styles.sidebar().listimg}
                            alt={category?.name}
                          />
                        )}
                      </ListItemIcon>
                      <ListItemText
                        primary={category?.name}
                        primaryTypographyProps={{
                          sx: { fontWeight: 'bold', fontSize: "17px" }, // Set font weight directly
                        }}
                      />
                      {category.hasPromo && <Cashback />}
                    </ListItem>

                    {/* Subcategories */}
                    <Collapse in={openCategory === index} timeout="auto" unmountOnExit>
                      <List component="div" disablePadding>
                        {sublist?.data?.map((sub, subIndex) => (
                          <ListItem
                            key={subIndex}
                            button
                            sx={Styles.sidebar(openCategory, opensubCategory, index, subIndex).sublist}
                            onClick={() => handleClick(subIndex, sub?.id, sub?.name)}
                          >
                            <ListItemIcon sx={Styles.sidebar().listicon} />
                            <ListItemText
                              primary={sub?.name}
                              primaryTypographyProps={{
                                sx: { fontWeight: 'normal', fontSize: "17px" },
                              }}
                            />
                          </ListItem>
                        ))}
                      </List>
                    </Collapse>
                  </React.Fragment>
                ))}
              </List>
            </Box >
          </SwipeableDrawer>
        </>}
    </>
  );
};

export default Sidebar;
